// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_DocumentsList_wrapper__2nEBa"};